import styled from '@emotion/styled';
import { Switch as MUISwitch } from '@mui/material';
import tw from 'twin.macro';

const StyledSwitch = styled(MUISwitch)`
  .MuiSwitch-track {
    ${tw`bg-white/80`}
  }

  .MuiSwitch-switchBase.Mui-checked {
    ${tw`text-brand-500`}
  }

  .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
    ${tw`bg-brand-500`}
  }

  .MuiSwitch-switchBase.Mui-disabled {
    ${tw`text-white/50`}
  }

  .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track {
    ${tw`bg-white/30 opacity-100`}
  }
`;

export const Switch = props => <StyledSwitch disableRipple {...props} />;
